import { buildPlayerZones } from "../init-game";
import type { DraftPickAction } from "../types/actions";
import type { PlayerId } from "../types/common";
import type { WarchestState } from "../types/game-state";
import { getOpponent } from "../utils/zone-utils";

export function applyDraftPick(
  state: WarchestState,
  action: DraftPickAction,
): WarchestState {
  const draftState = state.draftState!;
  const currentPicks = draftState.picks[action.player] ?? [];
  const newPicks = {
    ...draftState.picks,
    [action.player]: [...currentPicks, action.unitType],
  };
  const newAvailable = draftState.availableUnits.filter(
    (u) => u !== action.unitType,
  );
  const newDraftState = {
    ...draftState,
    availableUnits: newAvailable,
    picks: newPicks,
  };

  const p1Picks = newPicks["P1"] ?? [];
  const p2Picks = newPicks["P2"] ?? [];
  const draftComplete =
    p1Picks.length >= draftState.unitsPerPlayer &&
    p2Picks.length >= draftState.unitsPerPlayer;

  if (draftComplete) {
    // Transition to DRAW_COINS: build player zones from draft picks
    let rngState = state.rngState;
    const p1Result = buildPlayerZones(p1Picks, rngState, state.config);
    rngState = p1Result.rngState;
    const p2Result = buildPlayerZones(p2Picks, rngState, state.config);
    rngState = p2Result.rngState;
    return {
      ...state,
      phase: "DRAW_COINS",
      draftState: null,
      playerZones: { P1: p1Result.zones, P2: p2Result.zones },
      rngState,
    };
  }

  return {
    ...state,
    draftState: newDraftState,
    activePlayer: getOpponent(action.player) as PlayerId,
  };
}
